// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"88f508ae","952":"c513e379"}[chunkId] + ".chunk.js";
};